// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2xUYC","head":"Table_head__1nj5_","col":"Table_col__3TWSM"};